import { getApiUrlPath } from '@/models/constant'
import { GenericService } from '@/models/shared'
import { IPolicyActionResponse } from './response'
import { IPolicyActionRequest } from './request'


export class PolicyActionFactory extends GenericService<IPolicyActionRequest,
  IPolicyActionResponse> {
  constructor() {
    super({
      prefix: getApiUrlPath('PolicyAction')
    })
  }
}

